import React from 'react';
import './Download.css';
import googlePlay from '../assets/googlePlay.svg';
import appStore from '../assets/appStore.svg';

const Download: React.FC = () => {
  return (
    <section id="download" className="download">
      <div className="container">
        <div className="download-content">
          <div className="download-text">
            <h2 className="section-title">Mutfaktaki Devrime Katılın!</h2>
            <p className="section-subtitle">
              Yapay zeka ile pişirme deneyimini yeniden keşfedin. FoodQuick'i şimdi ücretsiz indirin ve ilk akıllı tarifinizi saniyeler içinde oluşturun.
            </p>
            
            <div className="download-buttons">
              <a href="https://apps.apple.com/app/foodquick-ai-recipe-generator/id6749247976" className="download-btn">
                <img src={appStore} alt="Download on the App Store" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.engdeveloper.foodquick" className="download-btn">
                <img src={googlePlay} alt="Get it on Google Play" />
              </a>
            </div>

           
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;
